// localStorage keys used across the application
export const LOCAL_STORAGE_KEYS = {
  // Visit History
  VISIT_HISTORY_ROWS_PER_PAGE: 'visitHistory.rowsPerPage',
  VISIT_HISTORY_FILTERS: 'visitHistory.filters',

  // Calendar
  CALENDAR_FILTERS: 'calendar.filters',

  // Organization Professional Visit History
  ORG_PROFESSIONAL_VISIT_HISTORY_ROWS_PER_PAGE:
    'organizationProfessionalVisitHistory.rowsPerPage',
  ORG_PROFESSIONAL_VISIT_HISTORY_FILTERS:
    'organizationProfessionalVisitHistory.filters',

  // Organization Patients List
  ORG_PATIENTS_ROWS_PER_PAGE: 'organizationPatients.rowsPerPage',
  ORG_PATIENTS_FILTERS: 'organizationPatients.filters',

  // Booking Flow
  BOOKING_ACTIVE_STEP: 'activeStep',
  BOOKING_STEPS_FORM_VALUES: 'stepsFormValues',
} as const;
